<template>
  <!-- Filled circle-alert (WarningCircleFill): v2 §Banners & Toast error glyph — a FILLED
       circle with a knocked-out "!", distinct from the ⚠ warning triangle (warning.vue).
       All currentColor so it themes (red for error banners/toasts; light + dark). -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
    <rect width="256" height="256" fill="none" />
    <path
      d="M128,24A104,104,0,1,0,232,128,104.13,104.13,0,0,0,128,24Zm-8,56a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z"
      fill="currentColor"
    />
  </svg>
</template>
